import { MantineTheme, createStyles } from "@mantine/core";

export const useStyle = createStyles((theme: MantineTheme) => ({
  divider: {
    marginBottom: "40px !important",
  },
}));
